import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { Config } from '../../config/config';
@Injectable()
export class CauHinhEmailQuyTrinhService {

    controller:string = 'HT_CauHinhEmailQuyTrinh';
    constructor(private http: Http) { }
    
   
    GetListNhanVienTheoCoQuanQuyTrinhEmail(idCoQuan:number, idDonVi:number, idBuoc:number) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));

        return this.http.get(Config.apiUrl + this.controller+ '/GetListNhanVienTheoCoQuanQuyTrinhEmail?idCoQuan=' + idCoQuan + "&idDonVi=" + idDonVi+"&idBuoc="+idBuoc, { headers: headers }).map(resp => resp.json());    
    }
    ds_NhanVienTheoCoQuanQuyTrinhEmail(idCoQuan:number, idDonVi:number, idBuoc:number, idMucDo:number) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));

        return this.http.get(Config.apiUrl + 'HT_CauHinhEmailQuyTrinh/ds_NhanVienTheoCoQuanQuyTrinhEmail?idCoQuan=' + idCoQuan + "&idDonVi=" + idDonVi+"&idBuoc="+idBuoc+"&idMucDo="+idMucDo, { headers: headers }).map(resp => resp.json());    
    }
    GetListNhanVienNhanEmail(idBuoc:number) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));

        return this.http.get(Config.apiUrl +this.controller+ '/GetListNhanVienNhanEmail?idBuoc='+idBuoc, { headers: headers }).map(resp => resp.json());    
    }
    ds_NhanVienNhanEmail(idBuoc:number, idMucDo:number) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));

        return this.http.get(Config.apiUrl + 'HT_CauHinhEmailQuyTrinh/ds_NhanVienNhanEmail?idBuoc='+idBuoc+'&idMucDo='+idMucDo, { headers: headers }).map(resp => resp.json());    
    }
    addNhanVien(idBuoc: number,idMucDo:number, listNhanVien: number[]) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));

        return this.http.post(Config.apiUrl +this.controller+ '/addNhanVien?idBuoc=' + idBuoc+'&idMucDo='+idMucDo, JSON.stringify(listNhanVien), {
            headers: headers
        }).map(resp => resp.json())
    }
}


// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/quy-trinh-xu-ly/cau-hinh-email-quy-trinh.service.ts